import {
  GET_DATOS_DASHBOARD,
  GET_DATES_DASHBOARD,
  FIND_CORREO_BY_ID,
  DATOS_GRAFICA_MES_YEAR,
  REPORTE_DASHBOARD,
} from "@/apollo/queries/mail";
import { exQue } from "@/utils/gql";
import { formatYYYMMDD, meses } from "@/utils/time";

export const dashState = {
  correosEnviados: 0,
  correosMaximosPlan: 1000,
  yearsDashboard: [],
  monthsDashboard: [],
  datosGrafica: [],
  datosDashboard: {
    correos_creados: 0,
    correos_destinados: 0,
    correos_enviados: 0,
    correos_abiertos: 0,
    detalles_categoria: [],
    detalles_top_vistos: [],
  },
};
export const dashMutations = {
  SET_DASHBOARD_DATES(state, dates) {
    state.yearsDashboard = [];
    state.monthsDashboard = [];

    if (dates && dates.length > 0) {
      state.yearsDashboard = dates.map((d, index) => ({
        text: d.year,
        value: parseInt(d.year),
        position: index,
      }));

      const firstYear = dates[0];
      const monthsAsNumbers = firstYear.months.map((m) => parseInt(m));
      state.monthsDashboard = meses.map((month) => ({
        ...month,
        selectable: monthsAsNumbers.includes(Number(month.value)),
      }));
    }
  },
  SET_DASHBOARD_DATA(state, { res, grafica }) {
    state.datosDashboard = res;
    state.datosGrafica = grafica;
  },
};
export const dashActions = {
  async getDatesDashboard({ commit }) {
    let res = await exQue(GET_DATES_DASHBOARD);
    commit("SET_DASHBOARD_DATES", res);
  },
  async getDatosDashboard({ commit }, { year, month }) {
    let [res, grafica] = await Promise.all([
      exQue(GET_DATOS_DASHBOARD, {
        year,
        month,
      }),
      exQue(DATOS_GRAFICA_MES_YEAR, { year }),
    ]);
    commit("SET_DASHBOARD_DATA", { res, grafica });
  },
  async findCorreoById(_, idCorreo) {
    let res = await exQue(FIND_CORREO_BY_ID, {
      idCorreo,
    });
    return res;
  },
  async reporte(_, { init, end }) {
    if (!end) end = formatYYYMMDD(new Date());
    init = formatYYYMMDD(init);

    let res = await exQue(REPORTE_DASHBOARD, {
      fechaInicio: init,
      fechaFin: end,
    });

    const respfrmt = res.map((item) => ({
      ...item,
      remitente: item.remitente.nombre_remitent,
      remitente_correo: item.remitente.correo_remitente,
      adjuntos: item.adjuntos.reduce((acc, curr) => {
        return `${acc} ${curr.nombre_adjunto}(${curr.url_adjunto}), `;
      }, ""),
      estado: item.estado.nombre_estado,
      categoria: item.categoria.nombre_categoria,
      destinatarios: item.destinatarios.reduce((acc, curr) => {
        if (!curr.usuario) return acc;
        return `${acc} ${curr.usuario.primer_nombre} ${curr.usuario.apellido_paterno}(${curr.usuario.correo}), `;
      }, ""),
      destinatarios_listas: item.destinatarios
        .map((d) => (d.lista ? d.lista.nombre_lista : ""))
        .filter((d) => d !== "")
        .join(", "),
    }));

    return respfrmt;
  },
};
